import React from 'react';
import {Box, Grid, TextField, Typography, Button, Autocomplete} from "@mui/material";
import swal from "sweetalert";
import {getAllSystemPrompts, updateSystemPrompts} from '../../../utilityFunctions/WellnessUtil';
import Colors from "../../../components/ui/Colors";
import CustomLoader from "../../../components/CustomLoader";
import { useHistory } from "react-router-dom";

const promptRequest={};

export default function ManageSystemPrompts(props) {

    const {loginUser} = props;

    let history = useHistory();

    const [loading, setLoading] = React.useState(false);

    const [systemPrompts, setSystemPrompts] = React.useState(null);
    const [systemPrompt, setSystemPrompt] = React.useState(null);
    const [editableSystemPrompt, setEditableSystemPrompt] = React.useState(null);

    React.useEffect(() => {
        const loadInitialValues = async () => {
            await initialValues();
        }
        loadInitialValues();
    }, []);

    const initialValues = async () => {
        
        setLoading(true);
        const response = await getAllSystemPrompts(loginUser.jwtToken);
        setLoading(false);

        if(!response){
            swal({
                title: "Error",
                text: "Failed to get system prompts",
                icon: "error",
                button: "OK",
            });
            return;
        }
        console.log(response);
        setSystemPrompts(response);
    };

    const systemPromptChange = (e, value) => {
        if(!value){
            return;
        }

        setSystemPrompt(value);
        setEditableSystemPrompt(value.message);
        promptRequest.id = value.id;
        promptRequest.message = value.message;
    };

    const changeSystemPromptText = (e) => {
        setEditableSystemPrompt(e.target.value);
        promptRequest.message = e.target.value;
    }

    const submitPromptChange = async () => {
        setLoading(true);
        const response = await updateSystemPrompts(promptRequest, loginUser.jwtToken);
        setLoading(false);

        if(!response){
            swal({
                title: "Error",
                text: "Failed to modify system prompt",
                icon: "error",
                button: "OK",
            });
            return;
        }

        swal({
            title: "Success",
            text: "System prompt modified successfully",
            icon: "success",
            button: "OK",
        }).then(() => {
            history.push({
                pathname: "/handle_profile",
            })
        });
        return;
    }


    return (
        <Box sx={{display: "flex", justifyContent: "center", width: "100%", height: "100%"}}>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "95%",
                    height: "90%",
                    textAlign: "center",
                    marginTop: {xs: "1.3rem", sm: 0},
                }}
            >
                {loading ? <CustomLoader /> :
                    <Grid container direction="row" spacing={2} sx={{marginTop: "5rem", alignItems: "center"}}>
                        {systemPrompts &&
                            <>
                            <Grid item xs={12} sm={12} md={12} sx={{display: "flex", justifyContent: "center"}}>
                                <Autocomplete
                                    sx={{width: {xs: "90%", sm: "80%", md: "60%"}}}
                                    options={systemPrompts}
                                    getOptionLabel={(option) => `${option.reference} - ${option.subReference}`}
                                    clearOnEscape
                                    autoComplete = {true}
                                    noOptionsText = {"prompt not found"}
                                    fullWidth
                                    onChange={systemPromptChange}
                                    renderInput={(params) => (
                                        <TextField  {...params} label="System prompt" variant="standard" />
                                    )}
                                />
                            </Grid>
                            {systemPrompt && editableSystemPrompt &&
                            <>
                                <Grid item xs={12} sm={12} md={12} sx={{marginTop: "1rem"}}>
                                    <TextField
                                        variant="outlined"
                                        fullWidth={true}
                                        multiline
                                        rows={6}
                                        label={<Typography variant="body2">System prompt</Typography>}
                                        value={editableSystemPrompt}
                                        onChange={(e)=> changeSystemPromptText(e)}
                                        autoComplete="off"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12}>
                                    <Button onClick={submitPromptChange} variant="contained" sx={{backgroundColor: Colors.primary, marginTop: "2rem",}}>
                                        Submit
                                    </Button>
                                </Grid>
                            </>
                            }
                            </>
                        }
                    </Grid>
                }
            </Box>
        </Box>
    );
}
